import React from "react";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import styled from "styled-components";
import { isValNull, getPath } from "../../../utils/index";

const TripDetails = (props) => {
  const { tripDetails } = props;
  return (
    <React.Fragment>
      <FlexContainer>
        <p className={"bold"}> {tripDetails.flow_type} Trip</p>
      </FlexContainer>
      <div
        style={{
          width: "50%",
        }}
      >
        {getPath(tripDetails, "payout", []).map((item, index) => {
          return (
            <React.Fragment>
              <p
                style={{
                  color: variables.red500,
                  marginTop: 10,
                  fontWeight: "bold",
                }}
              >
                {getPath(tripDetails, "payout", []).length > 1 &&
                  "Order " + (index + 1)}
              </p>
              {item.order_details.map((order_detail, index2) => (
                <OrderPayWrapper>
                  <FlexContainer>
                    {order_detail.type != "ORDERPAY" && (
                      <p className={"semibold"}>{order_detail.type}</p>
                    )}
                    <TextLarge
                      align={getPath(order_detail, "address", []).length > 0}
                    >
                      {order_detail.name} <br />
                      <TextSmall>{order_detail.address}</TextSmall>
                    </TextLarge>

                    {getPath(order_detail, "amount", false) && (
                      <p className={"semibold"}>{order_detail.amount}</p>
                    )}
                  </FlexContainer>
                  {getPath(order_detail, "sections", []).map(
                    (section, index3) => (
                      <div className={"mt-10"}>
                        {section.components.map((component, index) => (
                          <FlexContainer>
                            <TextSmall>{component.title}</TextSmall>
                            <TextSmall>{component.value}</TextSmall>
                          </FlexContainer>
                        ))}
                      </div>
                    )
                  )}
                </OrderPayWrapper>
              ))}
            </React.Fragment>
          );
        })}
      </div>
    </React.Fragment>
  );
};
const OrderPayWrapper = styled.div`
  border: 0.5px solid #cfcfcf;
  padding: 10px 20px;
  margin: 10px 0;
`;

const TextLarge = styled.p`
  text-align: ${(props) => (props.align ? "right" : "left")};
  font-weight: bold;
  width: 50%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const TextSmall = styled.p`
  font-size: 12px !important;
  font-weight: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export default TripDetails;
